import { Loader2 } from 'lucide-react'

interface LoadingProps {
  text?: string
}

export default function Loading({ text = 'Loading...' }: LoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <Loader2 className="h-8 w-8 text-primary-500 animate-spin mb-4" />
      <p className="text-dark-400">{text}</p>
    </div>
  )
}
